<template>
  <div class="app-main-inner">
    <div style="width: fit-content">
      <div class="section">
        <el-form :disabled="readonly" :inline="true" label-position="left" label-width="75px">
          <el-checkbox v-model="job.warehousing">{{ $t('SeaExport.Storage') }}</el-checkbox>
          <el-checkbox v-model="job.international" style="margin-left: -20px;">{{ $t('SeaExport.InternationalTransport') }}</el-checkbox>
          <el-checkbox v-model="job.landTransportation" style="margin-left: -20px;">{{ $t('SeaExport.DeliveryToDoor') }}</el-checkbox>
          <el-checkbox v-model="job.customs" style="margin-left: -20px;" @change="job.customsBroker=job.customs?job.customsBroker:0;job.customsDeclarationType=job.customs?job.customsDeclarationType:-1">{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
          <el-checkbox v-model="job.insure" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
          <el-checkbox v-model="job.itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
          <el-checkbox v-model="job.usCustomsClearance" style="margin-left: -20px;">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
          <span
            v-if="!previewConfig"
            v-permission="['button_insurance_toInsure']"
            type="primary"
            :class="!isEdit?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
            style="min-width:50px!important;margin-left:15px"
            @click="()=>{if (!isEdit){toInsure()}}"
          >{{ $t('SeaExport.Insure') }}
          </span>
          <span v-if="!!templateName" class="blue" style="float: right;margin-right: 30px;line-height: 28px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
        </el-form>
      </div>
      <tab-booking-FCLUICustom-layout :element-blocks="elementBlocks">
        <el-form-item v-if="elementDict.jobNo.slaveVisible" slot="jobNo">
          <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
          <el-input v-model="job.jobNo" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.masterJobNo.slaveVisible" slot="masterJobNo">
          <line-label slot="label" :class="elementDict.masterJobNo.isRequire ? 'blue' : ''" :label="elementDict.masterJobNo.label" />
          <el-input :value="job.master?job.master.jobNo:''" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.customerRefNo.slaveVisible" slot="customerRefNo">
          <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
          <cargo-input v-model="job.customerRefNo" :disabled="readonly" :auto-uppercase="true" :trim="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.customerId.slaveVisible" slot="customerId">
          <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip v-show="sopImageA" no="sopImageA" :content="$t('SeaExport.SOPReceiver')" placement="right-end">
              <!-- el-tooltip挂在div上（因为not-click样式会导致el-tooltip失效，所以不能挂在img上）-->
              <div style="height: 28px;">
                <img
                  :class="job.customerId&&readonly?'':'not-click'"
                  :src="sopPic"
                  width="18"
                  style="padding: 5px 0;cursor: pointer"
                  @click="showSopReceiverDialog('customer',job.customerId)"
                >
              </div>
            </el-tooltip>
            <el-tooltip v-show="creditTip.showWarningImageA" :content="creditTip.warningImageATip" placement="right-end">
              <i class="el-icon-warning red" style="cursor: pointer" />
            </el-tooltip>
            <cargo-sales-company-select
              no="customerId"
              :disabled="customerEnabled"
              :method-params="{customer:true,active:true,companyLob:'airImport'}"
              :check-credit="true"
              :default-value="job.customerId||''"
              :placeholder="$t('SeaExport.RequiredItem')"
              :job="job"
              style="display: inline-block;width: 100%;"
              @parentCallBack="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
            />
          </div>
        </el-form-item>
        <template v-if="isZY">
          <el-form-item slot="saleProductCode">
            <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
            <cargo-advance-select
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_AllowSaleProduct"
              filterable
              no="allowSaleProduct"
              clearable
              :data-filter-function="p => p.statusEnabled && p.airImportEnabled"
              :default-value="job.saleProductCode || ''"
              @parentCallBack="p => {job.saleProductCode = p.value}"
            />
          </el-form-item>
          <el-form-item slot="fullOrInside">
            <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
            <cargo-advance-select
              :disabled="readonly"
              :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
              no="fullOrInside"
              clearable
              :default-value="job.fullOrInside || ''"
              @parentCallBack="p => {job.fullOrInside = p.value}"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.customerProperty.slaveVisible" slot="customerProperty">
          <line-label slot="label" :class="elementDict.customerProperty.isRequire ? 'blue' : ''" :label="elementDict.customerProperty.label" />
          <el-tooltip :content="customerTip" placement="bottom">
            <span v-show="customerLevel.customerName" class="orange">LV{{ customerLevel.level }}</span>
            <span v-show="customerLevel.customerName" style="color:#D3A73B">&nbsp;{{ customerLevel.customerName }}</span>
            <span v-show="contractStatusLabel" class="red">&nbsp;({{ contractStatusLabel }})</span>
            <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
            <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
              <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
            </span>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.customerContact.slaveVisible" slot="customerContact">
          <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
          <div style="display: flex;justify-content: space-between">
            <el-select v-model="job.customerContact" :disabled="readonly" no="customerContact" filterable :allow-create="true" placeholder=" ">
              <el-option v-for="(item,index) in contactList" :key="index" :label="item.contactPerson" :value="item.contactPerson" />
            </el-select>
            <el-link v-show="!isShowContactPersonDetail" no="Detail" @click="contactInfoDialog.visible=true">{{ $t('SeaExport.Detail') }}</el-link>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.contactTelephone.slaveVisible" slot="contactTelephone">
          <line-label slot="label" :class="elementDict.contactTelephone.isRequire ? 'blue' : ''" :label="elementDict.contactTelephone.label" />
          <el-input v-model="job.contactTelephone" :disabled="readonly" no="contactTelephone" />
        </el-form-item>
        <el-form-item v-if="elementDict.contactFax.slaveVisible" slot="contactFax">
          <line-label slot="label" :class="elementDict.contactFax.isRequire ? 'blue' : ''" :label="elementDict.contactFax.label" />
          <el-input v-model="job.contactFax" :disabled="readonly" no="contactFax" />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSource.slaveVisible" slot="cargoSource">
          <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
          <cargo-advance-select
            no="cargoSource"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.local_cache_CargoSource"
            callback-method-type="value"
            :default-value="job.cargoSource"
            :callback-params="{key:'cargoSource'}"
            :clearable="false"
            placeholder=" "
            @parentCallBack="cargoSource_Change"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customJobType.slaveVisible" slot="customJobType">
          <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
          <cargo-advance-select
            ref="customJobType"
            no="customJobType"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            :default-value="job.customJobType"
            :tag-name="isZh?'name':'englishName'"
            :method-params="{type:job.lob}"
            :static-options="customJobTypeList"
            placeholder=" "
            @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.secondaryCustomJobType.slaveVisible && job.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
          <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
          <cargo-advance-select
            ref="secondaryCustomJobType"
            no="secondaryCustomJobType"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :cache="false"
            :default-value="job.secondaryCustomJobType"
            :tag-name="isZh?'name':'englishName'"
            :static-options="secondaryCustomJobTypeList"
            @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.designationAgent.slaveVisible && job.cargoSource==='NC'" slot="designationAgent">
          <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip v-show="sopImageB" no="sopImageB" :content="$t('SeaExport.SOPReceiver')" placement="right-end">
              <!-- el-tooltip挂在div上（因为not-click样式会导致el-tooltip失效，所以不能挂在img上）-->
              <div style="height: 28px;">
                <img
                  :class="job.designationAgent&&readonly?'':'not-click'"
                  :src="sopPic"
                  width="18"
                  style="padding: 5px 0;cursor: pointer"
                  @click="showSopReceiverDialog('DesignationAgent',job.designationAgent)"
                >
              </div>
            </el-tooltip>
            <el-tooltip v-show="creditTip.showWarningImageB" :content="creditTip.warningImageBTip" placement="right-end">
              <i class="el-icon-warning" style="color: red;font-size: 18px; cursor: pointer" />
            </el-tooltip>
            <cargo-company-select
              no="designationAgent"
              :disabled="readonly"
              :method-params="{overseaAgent:true,active:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.designationAgent||''"
              tag-name="englishName"
              :placeholder="$t('SeaExport.RequiredItem')"
              style="display: inline-block;width: 100%;"
              @change="designationAgentChangeHandler"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.salesChannel.slaveVisible" slot="salesChannel">
          <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
          <el-input v-model="job.salesChannel" no="salesChannel" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.trustFromJob && elementDict.trustFromJob.slaveVisible" slot="trustFromJob">
          <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
          <el-input v-model="job.trustFromJob" no="trustFromJob" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.slaveVisible" slot="relatedJob">
          <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
          <el-input v-model="job.relatedJob" no="relatedJob" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingAgentId.slaveVisible" slot="loadingAgentId">
          <line-label slot="label" :class="elementDict.loadingAgentId.isRequire ? 'blue' : ''" :label="elementDict.loadingAgentId.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip v-show="sopImageC" no="sopImageC" :content="$t('SeaExport.SOPReceiver')" placement="right-end">
              <!-- el-tooltip挂在div上（因为not-click样式会导致el-tooltip失效，所以不能挂在img上）-->
              <div style="height: 28px;">
                <img
                  :class="job.loadingAgentId&&readonly?'':'not-click'"
                  :src="sopPic"
                  width="18"
                  style="padding: 5px 0;cursor: pointer"
                  @click="showSopReceiverDialog('PortOfLoadingAgent',job.loadingAgentId)"
                >
              </div>
            </el-tooltip>
            <el-tooltip v-show="creditTip.showWarningImageC" :content="creditTip.warningImageCTip" placement="right-end">
              <i class="el-icon-warning" style="color: red;font-size: 18px;cursor: pointer" />
            </el-tooltip>
            <cargo-company-select
              no="loadingAgentId"
              :disabled="readonly"
              :method-params="{overseaAgent:true,active:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.loadingAgentId||''"
              tag-name="englishName"
              style="display: inline-block;width: 100%;"
              placeholder=" "
              @change="loadingAgentChangeHandler"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.carrierId.slaveVisible" slot="carrierId">
          <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
          <cargo-advance-select
            :disabled="readonly || !carrierIdEnabled"
            no="carrierId"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{airCmp:true,companyLob:'airImport',active:true}"
            :callback-params="{key:'carrierId'}"
            tag-name="chineseName"
            callback-method-type="value"
            :default-value="job.carrierId || ''"
            placeholder=" "
            @parentCallBack="p=>{setJobSelectNum(p);airlineCompanyChange(p.value||0)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.voyageFlight.slaveVisible" slot="voyageFlight">
          <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
          <cargo-input v-model="job.voyageFlight" :disabled="readonly || !isLclMasterFlag" no="voyageFlight" :auto-uppercase="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingAgent.slaveVisible && bookingAgentVisible" slot="bookingAgent">
          <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
          <cargo-advance-select
            no="bookingAgent"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true,companyLob:'airImport',active:true}"
            :callback-params="{key:'bookingAgent'}"
            callback-method-type="value"
            :default-value="job.bookingAgent || ''"
            placeholder=" "
            @parentCallBack="obj=>{setJobSelectNum(obj);job.groundAgentId=job.bookingAgent}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exChangeAgent.slaveVisible" slot="exChangeAgent">
          <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
          <cargo-advance-select
            no="exChangeAgent"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true,companyLob:'airImport',active:true}"
            :callback-params="{key:'exChangeAgent'}"
            callback-method-type="value"
            :default-value="job.exChangeAgent || ''"
            placeholder=" "
            @parentCallBack="obj=>{setJobSelectNum(obj);}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.mbl.slaveVisible" slot="mbl">
          <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
          <el-tooltip :content="(job.express||mblCodeNumValidate)?'':$t('queryJob.TheDoesNotComplyRules')" placement="right-end">
            <div style="display: flex">
              <el-checkbox v-model="job.express" :disabled="readonly" no="express">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
              <cargo-input v-show="job.express" v-model="job.mbl" :disabled="readonly" no="mbl" :maxlength="32" :auto-uppercase="true" style="flex-grow: 1;" />
              <el-input
                v-show="!job.express"
                ref="mblCode"
                :value="mblCode"
                :disabled="readonly || !isLclMasterFlag"
                no="mblCode"
                maxlength="3"
                :class="mblCodeNumValidate?'':'red'"
                style="width: 80px;flex-grow: 1;"
                @input="onMblCodeInput"
                @blur="onMblCodeNumBlur"
              />
              <span v-show="!job.express" style="padding-right: 2px;padding-left: 1.5px;">-</span>
              <cargo-input
                v-show="!job.express"
                ref="mblNum"
                :value="mblNum"
                :disabled="readonly || !isLclMasterFlag"
                no="mblNum"
                :maxlength="8"
                :input-convert="filterNonDigit"
                :class="mblCodeNumValidate?'':'red'"
                style="width: 150px;flex-grow: 1;"
                @input="onMblNumInput"
                @blur="onMblCodeNumBlur"
              />
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.jobSoNo.slaveVisible" slot="jobSoNo" style="margin-right: -3px;">
          <line-label slot="label" :class="elementDict.jobSoNo.isRequire ? 'blue' : ''" :label="elementDict.jobSoNo.label" />
          <so-no-input v-model="job.jobSoNo" :disabled="readonly" no="jobSoNo" />
        </el-form-item>
        <el-form-item v-if="elementDict.hbl.slaveVisible" slot="hbl">
          <line-label slot="label" :class="elementDict.hbl.isRequire ? 'blue' : ''" :label="elementDict.hbl.label" />
          <cargo-input v-model="job.hbl" :disabled="readonly" no="hbl" :auto-uppercase="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlace.slaveVisible" slot="dispatchingPlace">
          <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
          <cargo-input v-model="job.dispatchingPlace" :disabled="readonly" no="dispatchingPlace" :auto-uppercase="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingPortCode.slaveVisible" slot="loadingPortCode">
          <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="job.loadingPortCode" :disabled="true" no="loadingPortCode" style="width: 60px;margin-right: 5px;" />
            <cargo-advance-select
              no="loadingPortCode"
              filterable
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_Airport"
              :default-value="valueMatch.loadingPortCode?job.loadingPortCode:''"
              :placeholder="$t('SeaExport.RequiredItem')"
              style="flex:1"
              @parentCallBack="obj=>{valueMatch.loadingPortCode=true;loadingPortCodeChange(obj)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.dischargingPortCode.slaveVisible" slot="dischargingPortCode">
          <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="job.dischargingPortCode" :disabled="true" no="dischargingPortCode" style="width: 60px;margin-right: 5px;" />
            <cargo-advance-select
              no="dischargingPortCode"
              filterable
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_Airport"
              :default-value="valueMatch.dischargingPortCode?job.dischargingPortCode:''"
              :placeholder="$t('SeaExport.RequiredItem')"
              style="flex:1"
              @parentCallBack="dischargingPortCode_Change"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPlace.slaveVisible" slot="destinationPlace">
          <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
          <cargo-input v-model="job.destinationPlace" :disabled="readonly" no="destinationPlace" :auto-uppercase="true" :placeholder="$t('SeaExport.RequiredItem')" />
        </el-form-item>
        <!--航线-->
        <el-form-item v-if="elementDict.regionName.slaveVisible" slot="regionName">
          <line-label slot="label" :class="elementDict.regionName.isRequire ? 'blue' : ''" :label="elementDict.regionName.label" />
          <el-input v-model="job.regionName" no="airline" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.customsBroker.slaveVisible" slot="customsBroker">
          <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
          <cargo-advance-select
            :disabled="readonly || !job.customs"
            no="customsBroker"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{customsBroker:true,active:true}"
            callback-method-type="value"
            :default-value="job.customsBroker||''"
            placeholder=" "
            :callback-params="{key:'customsBroker'}"
            @parentCallBack="setJobSelectNum"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customClaim.slaveVisible" slot="customClaim">
          <line-label slot="label" :class="elementDict.customClaim.isRequire ? 'blue' : ''" :label="elementDict.customClaim.label" />
          <cargo-advance-select
            no="customsMethod"
            :disabled="readonly || !job.customs"
            :select-type="selectTypeNames.basic_data_CustomsMode"
            :method-params="{serviceType:2}"
            tag-value="serialNum"
            filterable
            :default-value="job.customClaim"
            @parentCallBack="p=>{job.customClaim=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDeclarationType.slaveVisible && job.customClaim===1" slot="customsDeclarationType">
          <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
          <cargo-advance-select
            no="customsDeclarationType"
            :disabled="readonly || !job.customs"
            :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
            filterable
            :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
            :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
            @parentCallBack="p=>{job.customsDeclarationType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.tradeTerm.slaveVisible" slot="tradeTerm">
          <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
          <cargo-advance-select
            no="tradeTerm"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_TradeTerm"
            callback-method-type="value"
            :default-value="job.tradeTerm"
            :callback-params="{key:'tradeTerm'}"
            :clearable="false"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <template v-if="elementDict.cargoCode.slaveVisible" slot="cargoCode">
          <el-form-item>
            <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
            <cargo-advance-select
              no="cargoCode"
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_CargoInformation"
              filterable
              :callback-params="{key:'cargoCode'}"
              :default-value="job.cargoCode"
              placeholder=" "
              @parentCallBack="txtCargoInformationChangeHandler"
            />
          </el-form-item>
          <el-form-item>
            <cargo-input v-model="job.cargoName" :disabled="readonly || !job.cargoCode" no="cargoName" />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.deliveryAddress.slaveVisible" slot="deliveryAddress">
          <line-label slot="label" :class="elementDict.deliveryAddress.isRequire ? 'blue' : ''" :label="elementDict.deliveryAddress.label" />
          <cargo-rich-textarea
            v-model="job.deliveryAddress"
            no="deliveryAddress"
            :disabled="readonly"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress, undefined, val=>{job.deliveryAddress=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.transportSource.slaveVisible" slot="transportSource">
          <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
          <cargo-advance-select
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_TransportSource"
            no="transportSource"
            :default-value="job.transportSource"
            :cache="false"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>job.transportSource=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.statisticArea.slaveVisible" slot="statisticArea">
          <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
          <cargo-advance-select
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_StatisticArea"
            no="statisticArea"
            :default-value="job.statisticArea"
            :cache="false"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>job.statisticArea=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDate.slaveVisible" slot="customsDate">
          <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
          <el-date-picker v-model="job.customsDate" :disabled="readonly" no="customsDate" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable />
        </el-form-item>
        <el-form-item v-if="elementDict.etd.slaveVisible" slot="etd">
          <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.etd"
              :default-value="new Date()"
              :disabled="readonly || !isLclMasterFlag"
              no="etd"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder=""
              style="flex: 1; width:170px; margin-right: 5px"
              clearable
              @input="etdChange"
            />
            <span>{{ job.sailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.eta.slaveVisible" slot="eta">
          <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.eta"
              :default-value="new Date()"
              :disabled="readonly || !isLclMasterFlag"
              no="eta"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('SeaExport.RequiredItem')"
              style="flex: 1; width:170px; margin-right: 5px"
              clearable
              @change="etaChange"
            />
            <span>{{ job.etaSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.atd.slaveVisible" slot="atd">
          <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.atd"
              :default-value="new Date()"
              :disabled="readonly || !isLclMasterFlag"
              no="atd"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="flex: 1; width:170px; margin-right: 5px"
              clearable
              @input="atdChange"
            />
            <span>{{ job.atdSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.ata.slaveVisible" slot="ata">
          <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.ata"
              :default-value="new Date()"
              :disabled="readonly || !isLclMasterFlag"
              no="ata"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="flex: 1; width:170px; margin-right: 5px"
              clearable
              @input="ataChange"
            />
            <span>{{ job.ataSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <template v-if="elementDict.shipper.slaveVisible" slot="shipper">
          <el-form-item>
            <div style="display: flex;justify-content: flex-end">
              <el-button type="primary" :disabled="readonly" no="CopyFromOtherBill" @click="importPromptTitleDialog.visible=true">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
              <el-button type="primary" :disabled="readonly" no="CodeSearching" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
              <char-count :form="job" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
              <cargo-input v-model="job.shipperCode" :disabled="readonly" no="shipperCode" :auto-uppercase="true" :placeholder="readonly ? '': $t('Tool.Code')" style="width:90px;margin-right: 5px" @change="syncHbl('shipperCode')" />
              <cargo-advance-select
                no="shipperId"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{shipper:true,active:true}"
                :default-value="job.shipperId||''"
                tag-name="englishName"
                style="flex: 1"
                placeholder=" "
                @parentCallBack="shipperAutoCompleteChange"
              />
            </div>
          </el-form-item>
          <el-form-item v-for="i in 1" v-if="i>=1" :key="'shipperLine'+i" style="margin-top: -10px">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="job['shipperLine'+i]"
              :disabled="readonly"
              no="shipperLine1"
              :auto-uppercase="true"
              :use-read-only="true"
              :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
              @change="syncHbl('shipperLine1')"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),undefined,splitShipperLine)"
            />
          </el-form-item>
          <el-form-item v-for="i in 7" v-if="i>=2" v-show="false" :key="'shipperLine'+i">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="job['shipperLine'+i]"
              :disabled="readonly"
              :use-read-only="true"
              no="'shipperLine'+i"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.consignee.slaveVisible" slot="consignee">
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
              <char-count :form="job" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
              <cargo-input v-model="job.consigneeCode" :disabled="readonly" no="consigneeCode" :auto-uppercase="true" :placeholder="readonly ? '': $t('Tool.Code')" style="width:90px;margin-right: 5px" @change="syncHbl('consigneeCode')" />
              <cargo-advance-select
                no="consigneeId"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{consignee:true}"
                :default-value="job.consigneeId||''"
                tag-name="englishName"
                style="flex: 1"
                placeholder=" "
                @parentCallBack="consigneeAutoCompleteChange"
              />
            </div>
          </el-form-item>
          <el-form-item v-for="i in 1" v-if="i>=1" :key="'consigneeLine'+i" style="margin-top: -10px">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="job['consigneeLine'+i]"
              :disabled="readonly"
              no="consigneeLine1"
              :auto-uppercase="true"
              :use-read-only="true"
              :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
              @change="syncHbl('consigneeLine1')"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),undefined,splitConsigneeLine)"
            />
          </el-form-item>
          <el-form-item v-for="i in 7" v-if="i>1" v-show="false" :key="'consigneeLine'+i">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="job['consigneeLine'+i]"
              :disabled="readonly"
              :use-read-only="true"
              no="'consigneeLine'+i"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.notify.slaveVisible" slot="notify">
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
              <char-count :form="job" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
              <cargo-input v-model="job.notifyCode" :disabled="readonly" no="notifyCode" :auto-uppercase="true" :placeholder="readonly ? '': $t('Tool.Code')" style="width:90px;margin-right: 5px" @change="syncHbl('notifyCode')" />
              <cargo-advance-select
                no="notifyId"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{notify:true}"
                :default-value="job.notifyId||''"
                tag-name="englishName"
                style="flex: 1"
                placeholder=" "
                @parentCallBack="notifyAutoCompleteChange"
              />
            </div>
          </el-form-item>
          <el-form-item v-for="i in 1" v-if="i>=1" :key="'notifyLine'+i" style="margin-top: -10px">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="job['notifyLine'+i]"
              :disabled="readonly"
              no="notifyLine1"
              :auto-uppercase="true"
              :use-read-only="true"
              :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
              @change="syncHbl('notifyLine1')"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),undefined,splitNotifyLine)"
            />
          </el-form-item>
          <el-form-item v-for="i in 7" v-if="i>1" v-show="false" :key="'notifyLine'+i">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="job['notifyLine'+i]"
              :disabled="readonly"
              :use-read-only="true"
              no="'notifyLine'+i"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.quantityActual.slaveVisible" slot="quantityActual">
          <line-label slot="label" :class="elementDict.quantityActual.isRequire ? 'blue' : ''" :label="elementDict.quantityActual.label" />
          <auto-number-input
            v-model="job.quantityActual"
            :disabled="readonly"
            no="quantityContract"
            :precision="0"
            :min="0"
            @change="quantityChange"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.packing.slaveVisible" slot="packing">
          <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
          <cargo-packing-select
            no="packing"
            :disabled="readonly"
            :default-value="job.packing"
            placeholder=" "
            @change="p => {p.key = 'packing';setJobSelectValue(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.weightActual.slaveVisible" slot="weightActual">
          <line-label slot="label" :class="elementDict.weightActual.isRequire ? 'blue' : ''" :label="elementDict.weightActual.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.weightActual"
              :disabled="readonly"
              no="weightContract"
              :precision="3"
              :min="0"
              @change="weightContractChange"
            />
            <div style="font-size: 12px;font-weight: normal;color: #404144">
              <span>KGS</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cubageActual.slaveVisible" slot="cubageActual">
          <line-label slot="label" :class="elementDict.cubageActual.isRequire ? 'blue' : ''" :label="elementDict.cubageActual.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.cubageActual"
              :disabled="readonly"
              no="cubageContract"
              :precision="3"
              :min="0"
              @change="cubageContractChange"
            />
            <div style="font-size: 12px;font-weight: normal;color: #404144">
              <span>CBM</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.chargeWeight.slaveVisible" slot="chargeWeight">
          <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
          <auto-number-input
            v-model="job.chargeWeight"
            :disabled="readonly"
            no="chargeWeight"
            :precision="3"
            :min="0"
            @change="syncChargeWeightToCharge();syncHbl('chargeWeight', 'cWeight')"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoChineseName.slaveVisible" slot="cargoChineseName">
          <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <div style="position:relative">
            <cargo-input
              v-model="job.cargoChineseName"
              :disabled="readonly"
              no="cargoChineseName"
              type="textarea"
              :rows="3"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog(elementDict.cargoChineseName.label,job.cargoChineseName,0,val=>{job.cargoChineseName=val})"
            />
            <char-count :value="job.cargoChineseName" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoEnglishName.slaveVisible" slot="cargoEnglishName">
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <div style="position:relative">
            <cargo-input
              v-model="job.cargoEnglishName"
              :disabled="readonly"
              no="cargoEnglishName"
              type="textarea"
              :rows="3"
              :auto-uppercase="isUppercaseByConfig"
              @change="syncHbl('cargoEnglishName')"
              @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.label,job.cargoEnglishName,0,val=>{job.cargoEnglishName=val},isUppercaseByConfig)"
            />
            <char-count :value="job.cargoEnglishName" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.mark.slaveVisible" slot="mark">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <div style="position:relative">
            <cargo-input
              v-model="job.mark"
              :disabled="readonly"
              no="mark"
              type="textarea"
              :rows="3"
              :auto-uppercase="isUppercaseByConfig"
              @change="syncHbl('mark', 'remark1')"
              @dblclick.native="showAdvanceTextDialog(elementDict.mark.label,job.mark,0,val=>{job.mark=val},isUppercaseByConfig)"
            />
            <char-count :value="job.mark" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.depositReceived.slaveVisible" slot="depositReceived">
          <line-label slot="label" :class="elementDict.depositReceived.isRequire ? 'blue' : ''" :label="elementDict.depositReceived.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input-number v-model="job.depositReceived" :disabled="readonly" no="depositReceived" style="flex-grow: 1" :controls="false" :precision="3" />
            <span>{{ localCurrency }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.remarks.slaveVisible" slot="remarks">
          <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
          <cargo-input
            v-model="job.remarks"
            :disabled="readonly"
            no="remarks"
            type="textarea"
            :rows="3"
            :auto-uppercase="true"
            @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,job.remarks,0,val=>{job.remarks=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.poNo.slaveVisible" slot="poNo" :class="poNoRed?'poNoClass':''">
          <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
          <cargo-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="readonly" no="poNo" :auto-uppercase="true" />
          <cargo-project-select
            v-if="openProjectConfig"
            :disabled="readonly"
            no="poNo"
            :default-value="job.poNo"
            :customer-id="job.customerId"
            @change="changeProject"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.projectName.slaveVisible && openProjectConfig" slot="projectName">
          <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
          <el-input v-model="job.projectName" :disabled="true" no="projectName" />
        </el-form-item>
        <el-form-item v-if="elementDict.projectBatch.slaveVisible && openProjectConfig" slot="projectBatch">
          <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
          <el-input v-model="job.projectBatch" no="projectBatch" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.operateType.slaveVisible" slot="operateType">
          <line-label slot="label" :class="elementDict.operateType.isRequire ? 'blue' : ''" :label="elementDict.operateType.label" />
          <cargo-advance-select
            :disabled="readonly || !isLclMasterFlag"
            no="operateType"
            filterable
            :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeAirInputList"
            callback-method-type="value"
            :default-value="job.operateType"
            :callback-params="{key:'operateType'}"
            :clearable="false"
            @parentCallBack="operateType_changeHandler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.freightTerm.slaveVisible" slot="freightTerm">
          <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
          <cargo-advance-select
            no="freightTerm"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_ShippingTerm"
            callback-method-type="value"
            :default-value="job.freightTerm"
            :callback-params="{key:'freightTerm'}"
            :clearable="false"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoType.slaveVisible" slot="cargoType">
          <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
          <cargo-advance-select
            no="cargoType"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CargoType"
            :method-params="{air:true}"
            callback-method-type="value"
            :default-value="job.cargoType"
            :callback-params="{key:'cargoType'}"
            :clearable="false"
            @parentCallBack="onCargoTypeChagne"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermHBL.slaveVisible" slot="paymentTermHBL">
          <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
          <cargo-advance-select
            no="paymentTermHBL"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            callback-method-type="value"
            :default-value="job.paymentTermHBL"
            :callback-params="{key:'paymentTermHBL'}"
            :clearable="false"
            placeholder=" "
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermMBL.slaveVisible" slot="paymentTermMBL">
          <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
          <cargo-advance-select
            :disabled="readonly || !isLclMasterFlag"
            no="paymentTermMBL"
            filterable
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            callback-method-type="value"
            :default-value="job.paymentTermMBL"
            :callback-params="{key:'paymentTermMBL'}"
            :clearable="false"
            placeholder=" "
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.incoTerm.slaveVisible" slot="incoTerm">
          <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
          <cargo-advance-select
            no="incoTerm"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_IncoTerm"
            callback-method-type="value"
            :default-value="job.incoTerm"
            :callback-params="{key:'incoTerm'}"
            :clearable="false"
            placeholder=" "
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.transDate.slaveVisible" slot="transDate">
          <line-label slot="label" :class="elementDict.transDate.isRequire ? 'blue' : ''" :label="elementDict.transDate.label" />
          <el-date-picker v-model="job.transDate" :disabled="readonly" no="transDate" type="date" value-format="yyyy-MM-dd" style="width:100%;" clearable />
        </el-form-item>
        <el-form-item v-if="elementDict.deliverDate.slaveVisible" slot="deliverDate">
          <line-label slot="label" :class="elementDict.deliverDate.isRequire ? 'blue' : ''" :label="elementDict.deliverDate.label" />
          <el-date-picker v-model="job.deliverDate" :disabled="readonly" no="deliverDate" type="date" value-format="yyyy-MM-dd" style="width:100%;" clearable />
        </el-form-item>
        <el-form-item v-if="elementDict.arriveStorageDate.slaveVisible" slot="arriveStorageDate">
          <line-label slot="label" :class="elementDict.arriveStorageDate.isRequire ? 'blue' : ''" :label="elementDict.arriveStorageDate.label" />
          <el-date-picker v-model="job.arriveStorageDate" :disabled="readonly" no="arriveStorageDate" type="date" value-format="yyyy-MM-dd" style="width:100%;" clearable />
        </el-form-item>
        <el-form-item v-if="elementDict.groundAgentId.slaveVisible" slot="groundAgentId">
          <line-label slot="label" :class="elementDict.groundAgentId.isRequire ? 'blue' : ''" :label="elementDict.groundAgentId.label" />
          <cargo-advance-select
            no="groundAgentId"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true,active:true}"
            :callback-params="{key:'groundAgentId'}"
            callback-method-type="value"
            :default-value="job.groundAgentId||''"
            placeholder=" "
            @parentCallBack="setJobSelectNum"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.txtSalesOffice.slaveVisible" slot="txtSalesOffice">
          <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
          <el-input v-model="txtSalesOffice" :disabled="true" no="txtSalesOffice" :placeholder="$t('SeaExport.RequiredItem')" />
        </el-form-item>
        <el-form-item v-if="elementDict.sales.slaveVisible" slot="sales">
          <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-user-select
              ref="sales"
              :disabled="readonly || isWithinCloseAccountDate"
              no="sales"
              :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
              :default-value="job.sales||''"
              :static-options="salesList"
              style="flex: 1"
              placeholder=" "
              @change="salesChangeHandler"
            />
            <el-checkbox
              v-model="job.provisioned"
              :disabled="true"
              no="provisioned"
              style="margin-left: 5px;margin-right: 0px;"
            >{{ $t('SeaExport.Accrued') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSalesId.slaveVisible" slot="cargoSalesId">
          <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
          <cargo-user-select
            no="cargoSalesId"
            :disabled="readonly"
            :method-params="{category:'role',shape:'salesOfGoods'}"
            :default-value="job.cargoSalesId||''"
            placeholder=" "
            :static-options="cargoSalesList"
            @change="cargoSalesChargeHandler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesDepartment.slaveVisible" slot="salesDepartment">
          <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
          <cargo-department-new-select
            :disabled="readonly || !job.sales"
            no="salesOffice"
            :sales-id="Number(job.sales)"
            :enables="true"
            :office-id="job.salesOffice"
            :department-id="Number(job.salesDepartment)"
            placeholder=" "
            @change="departmentChangeHandler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opOffice.slaveVisible" slot="opOffice">
          <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
          <cargo-advance-select
            no="opOffice"
            :disabled="readonly || opOfficeDisabled"
            :select-type="selectTypeNames.basic_data_Office"
            filterable
            :callback-params="{key:'opOffice'}"
            :static-options="cacheOffices"
            callback-method-type="value"
            :default-value="job.opOffice||''"
            placeholder=" "
            @parentCallBack="p=>{setJobSelectNum(p);job.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange(job.customerId, job.designationAgent)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opDepartment.slaveVisible" slot="opDepartment">
          <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
          <cargo-department-select
            :disabled="readonly || isWithinCloseAccountDate"
            no="opDepartment"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :department-id="Number(job.opDepartment)"
            placeholder=" "
            @change="p=>{job.opDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrOffice.slaveVisible" slot="csrOffice">
          <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
          <cargo-office-select
            no="csrOffice"
            :disabled="true"
            :office-id="Number(job.csrOffice)"
            @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrDepartment.slaveVisible" slot="csrDepartment">
          <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
          <cargo-department-select
            no="csrDepartment"
            :disabled="readonly"
            :office-id="Number(job.csrOffice)"
            :enables="true"
            :department-id="Number(job.csrDepartment)"
            @change="p=>{job.csrDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csr.slaveVisible" slot="csr">
          <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
          <cargo-user-select
            no="csr"
            :disabled="readonly"
            :method-params="{category:'role',shape:'csr'}"
            :default-value="job.csr||''"
            placeholder=" "
            :static-options="userPortRoleData.csr"
            @change="csrChangeHandler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.op.slaveVisible" slot="op">
          <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
          <cargo-user-select no="op" :disabled="readonly" :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOffice.code==='HB'?'':$store.getters.currentOfficeId}" :default-value="job.op||''" placeholder=" " :static-options="userPortRoleData.op" @change="opChangeHandler" />
        </el-form-item>
        <el-form-item v-if="elementDict.dcOffice.slaveVisible" slot="dcOffice">
          <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
          <cargo-office-select
            no="dcOffice"
            :disabled="true"
            :office-id="Number(job.dcOffice)"
            @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcDepartment.slaveVisible" slot="dcDepartment">
          <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
          <cargo-department-select
            no="dcDepartment"
            :disabled="readonly"
            :office-id="Number(job.dcOffice)"
            :enables="true"
            :department-id="Number(job.dcDepartment)"
            @change="p=>{job.dcDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dc.slaveVisible" slot="dc">
          <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
          <cargo-user-select no="dc" :disabled="readonly" :method-params="{category:'role',shape:'doc'}" :default-value="job.dc||''" placeholder=" " :static-options="userPortRoleData.doc" @change="dcChangeHandler" />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.slaveVisible" slot="plannerOffice">
          <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
          <cargo-office-select
            no="plannerOffice"
            :disabled="true"
            :office-id="Number(job.plannerOffice)"
            @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.slaveVisible" slot="plannerDepartment">
          <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
          <cargo-department-select
            no="plannerDepartment"
            :disabled="readonly"
            :office-id="Number(job.plannerOffice)"
            :enables="true"
            :department-id="Number(job.plannerDepartment)"
            @change="p=>{job.plannerDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.planner.slaveVisible" slot="planner">
          <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
          <cargo-user-select
            no="planner"
            :disabled="readonly"
            :method-params="{category:'role',shape:'airline'}"
            :default-value="job.planner||''"
            placeholder=" "
            :static-options="userPortRoleData.airline"
            @change="plannerChangeHandler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingPortOp.slaveVisible" slot="loadingPortOp">
          <line-label slot="label" :class="elementDict.loadingPortOp.isRequire ? 'blue' : ''" :label="elementDict.loadingPortOp.label" />
          <cargo-user-select
            no="loadingPortOp"
            :disabled="readonly"
            :method-params="{category:'role',shape:'aiop'}"
            :default-value="job.loadingPortOp||''"
            placeholder=" "
            @change="p=>{job.loadingPortOp=p.value||0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortOp.slaveVisible" slot="destinationPortOp">
          <line-label slot="label" :class="elementDict.destinationPortOp.isRequire ? 'blue' : ''" :label="elementDict.destinationPortOp.label" />
          <cargo-user-select
            no="destinationPortOp"
            :disabled="readonly"
            :method-params="{category:'role',shape:'aiop'}"
            :default-value="job.destinationPortOp||''"
            placeholder=" "
            @change="p=>{job.destinationPortOp=p.value||0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.siteOP.slaveVisible" slot="siteOP">
          <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
          <cargo-user-select
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
            :default-value="job.siteOP||''"
            placeholder=" "
            :static-options="userPortRoleData.siteOp"
            @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.overseaOp.slaveVisible" slot="overseaOp">
          <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
          <cargo-user-select
            ref="overseaOp"
            no="overseaOp"
            class="input2"
            :disabled="readonly"
            :default-value="job.overseaOp||''"
            :method-params="{category:'role',shape:'overseaOp'}"
            :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
            :merge-load="true"
            @change="p=>{
              job.overseaOp = p.value
              OverseaCustomerUtils.overseaOpChangeHandler(view, p)
            }"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId1.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            ref="userDefinedRoleId1"
            no="userDefinedRoleId1"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="job.userDefinedRoleId1||''"
            :merge-load="true"
            placeholder=" "
            @change="p=>{userDefinedRoleId1Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId2.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            ref="userDefinedRoleId2"
            no="userDefinedRoleId2"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="job.userDefinedRoleId2||''"
            :merge-load="true"
            placeholder=" "
            @change="p=>{userDefinedRoleId2Handler(p)}"
          />
        </el-form-item>
        <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.slaveVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
          <micro-app
            name="child-user-defined-role-ai-userDefinedRoleId3"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div>
        <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.slaveVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
          <micro-app
            name="child-user-defined-role-ai-userDefinedRoleId4"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div> -->
        <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
          <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
          <cargo-user-select
            ref="userDefinedRoleId3"
            no="userDefinedRoleId3"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
            :default-value="job.userDefinedRoleId3||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole3"
            @change="p=>{userDefinedRoleId3Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
          <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
          <cargo-user-select
            ref="userDefinedRoleId4"
            no="userDefinedRoleId4"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
            :default-value="job.userDefinedRoleId4||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole4"
            @change="p=>{userDefinedRoleId4Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
          <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
          <cargo-user-select
            ref="userDefinedRoleId5"
            no="userDefinedRoleId5"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
            :default-value="job.userDefinedRoleId5||''"
            :merge-load="true"
            @change="p=>{userDefinedRoleId5Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
          <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
          <cargo-user-select
            ref="userDefinedRoleId6"
            no="userDefinedRoleId6"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
            :default-value="job.userDefinedRoleId6||''"
            :merge-load="true"
            @change="p=>{userDefinedRoleId6Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
          <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
          <cargo-user-select
            ref="userDefinedRoleId7"
            no="userDefinedRoleId7"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
            :default-value="job.userDefinedRoleId7||''"
            :merge-load="true"
            @change="p=>{userDefinedRoleId7Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
          <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
          <cargo-user-select
            ref="userDefinedRoleId8"
            no="userDefinedRoleId8"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
            :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
            :disabled="readonly"
            :multiple="true"
            :merge-load="true"
            :placeholder="readonly ? ' ' : ''"
            @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
          />
        </el-form-item>
        <div v-if="elementDict.satisfiedRequests.slaveVisible" slot="satisfiedRequests">
          <special-requests-grid
            v-model="job.satisfiedRequests"
            :disabled="readonly"
            no="satisfiedRequests"
            :is-edit="isEdit"
            :customer-id="Number(job.customerId)"
            :lob="job.lob"
            :job="job"
          />
        </div>
        <el-form-item v-if="elementDict.userDefinedField1.slaveVisible" slot="userDefinedField1">
          <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
          <el-input
            v-model="job.userDefinedField1"
            :disabled="readonly"
            no="userDefinedField1"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,0,val=>{job.userDefinedField1=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField2.slaveVisible" slot="userDefinedField2">
          <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
          <el-input
            v-model="job.userDefinedField2"
            :disabled="readonly"
            no="userDefinedField2"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,0,val=>{job.userDefinedField2=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField3.slaveVisible" slot="userDefinedField3">
          <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
          <el-input
            v-model="job.userDefinedField3"
            :disabled="readonly"
            no="userDefinedField3"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,0,val=>{job.userDefinedField3=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField4.slaveVisible" slot="userDefinedField4">
          <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
          <el-input
            v-model="job.userDefinedField4"
            :disabled="readonly"
            no="userDefinedField4"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,job.userDefinedField4,0,val=>{job.userDefinedField4=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.slaveVisible" slot="taxNature">
          <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
          <el-select
            v-model="job.taxNature"
            :disabled="readonly"
            no="taxNature"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in TAX_NATURES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.rateType && elementDict.rateType.slaveVisible" slot="rateType">
          <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
          <el-select
            v-model="job.rateType"
            :disabled="readonly"
            no="rateType"
            clearable
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in rateType"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
      </tab-booking-FCLUICustom-layout>
      <!-- SOP接收人弹窗 -->
      <sop-dialog
        :visible.sync="sopDialog.visible"
        :cmp-idx="sopDialog.cmpIdx"
        :job="job"
        :agent="sopDialog.agent"
        lob="AI"
        :contact-list="sopDialog.contactList"
        @updateJob="$emit('updateJob')"
      />
      <cargo-contacts-info-dialog
        v-if="contactInfoDialog.visible"
        :visible.sync="contactInfoDialog.visible"
        :customer-id="job.customerId"
        :customer-contact="job.customerContact"
      />
      <!-- 单号抄录 -->
      <import-prompt-title-dialog :visible.sync="importPromptTitleDialog.visible" :lob="job.lob" @selected="onExcerptionChangeFunc" />
      <!-- 代码检索 -->
      <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="codeSearchCallback" />
      <!-- 高级文本弹框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="advanceTextDialog.visible"
        :title="advanceTextDialog.title"
        width="665px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <cargo-rich-textarea
          v-model="advanceTextDialog.value"
          :disabled="readonly"
          :text-chars="advanceTextDialog.textChars"
          :auto-uppercase="advanceTextDialog.isUppercase"
          :warning-count="-1"
          style="height: 320px;"
        />
        <span slot="footer">
          <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
        </span>
      </el-dialog>
      <!-- 订舱章弹窗 -->
      <stamp-picture-view
        :visible.sync="stampPictureView.visible"
        :business-documents="stampPictureView.businessDocuments"
      />
    </div>
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabBookingFCLUICustomLayout from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCLUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabBookingFCL from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCL.vue'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabBookingFCLUICustom',
  components: { tabBookingFCLUICustomLayout },
  extends: tabBookingFCL,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.AI_BOOKING_BASIC, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    async validateForm() {
      const form = this.job
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.slaveVisible && field.isRequire) {
          if (key === 'operateType') {
            if (ColumnUtils.operateTypeLabelFunc(form, key)) {
              continue
            } else {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          }
          if (key === 'secondaryCustomJobType') {
            if (!(this.job.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (key === 'projectName' || key === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (key === 'customClaim') {
            const obj = getObjectByCache(TYPE_NAMES.basic_data_CustomsMode, 'serialNum', form.customClaim)
            if (!obj) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (key === 'cargoCode') {
            if (StrUtils.isEmpty(form.cargoCode) || StrUtils.isEmpty(form.cargoName)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          }
        }
      }
      if (this.elementDict.jobSoNo.slaveVisible && this.elementDict.jobSoNo.isRequire) {
        if (StrUtils.isEmpty(form.jobSoNo)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.jobSoNo.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.regionName.slaveVisible && this.elementDict.regionName.isRequire) {
        if (StrUtils.isEmpty(form.regionName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.regionName.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.shipper.slaveVisible && this.elementDict.shipper.isRequire) {
        let shipperLine = ''
        for (let i = 1; i <= 7; ++i) {
          shipperLine += form['shipperLine' + i]
        }
        if (StrUtils.isEmpty(shipperLine) && StrUtils.isEmpty(form.shipperCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.shipper.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.consignee.slaveVisible && this.elementDict.consignee.isRequire) {
        let consigneeLine = ''
        for (let i = 1; i <= 7; ++i) {
          consigneeLine += form['consigneeLine' + i]
        }
        if (StrUtils.isEmpty(consigneeLine) && StrUtils.isEmpty(form.consigneeCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.consignee.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.notify.slaveVisible && this.elementDict.notify.isRequire) {
        let notifyLine = ''
        for (let i = 1; i <= 7; ++i) {
          notifyLine += form['notifyLine' + i]
        }
        if (StrUtils.isEmpty(notifyLine) && StrUtils.isEmpty(form.notifyCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.notify.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.customsDeclarationType.slaveVisible && this.job.customClaim === 1 && this.elementDict.customsDeclarationType.isRequire && this.job.customs) {
        if (form.customsDeclarationType === -1 || !ColumnUtils.customClaim2LabelFunc(form.customsDeclarationType)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.customsDeclarationType.label]), 'tabBookingFCL')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-ai-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-ai-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .section ::v-deep {
  .job-no-color.el-input {
    .el-input__inner {
      background: #99ff66 !important;
    }
  }
  .red {
    .el-input__inner {
      color: #f56c6c !important;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
